import * as React from 'react';
import styled from 'styled-components';

import { Show } from 'src/components/condition';
import { windowSize } from 'src/stores/windowSize';
import { Icon } from 'src/styledComponents/Icons';
import { Utility } from 'src/styledComponents/Typography';

const StyleOption = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0 16px;
  height: 56px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};

  .option-label {
    color: ${(props) => (props.disabled ? props.theme.main.colors.clay3 : 'inherit')};
  }

  &:hover {
    background: ${(props) => props.theme.main.colors.clay6};
  }
`;

const Note = styled.span`
  flex-shrink: 0;
  margin-left: 12px;
  padding: 4px 10px;
  border-radius: 100px;
  background: ${(props) => props.theme.main.colors.clay7};
  color: ${(props) => props.theme.main.colors.clay3};
  font-size: 11px;
  line-height: 14px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  white-space: nowrap;
`;

type Props = {
  label: string;
  active: boolean;
  handleSelect: AnyFunction;
  disabled?: boolean;
  note?: string;
};

export const Option: React.FC<Props> = (props) => {
  const { label, active, handleSelect, disabled, note } = props;
  const variant = windowSize.isGreaterThan('medium') ? 'u2' : 'u1';

  return (
    <StyleOption onClick={disabled ? () => {} : handleSelect} disabled={disabled}>
      <Utility variant={variant} weight='medium' className='option-label' truncate={Boolean(note)}>
        {label}
      </Utility>
      <Show if={Boolean(note)}>
        <Note>{note}</Note>
      </Show>
      <Show if={active && !note}>
        <Icon name='FormTick' size={16} />
      </Show>
    </StyleOption>
  );
};
